import { render, staticRenderFns } from "./NewHistoryPage.vue?vue&type=template&id=709d1308"
import script from "./NewHistoryPage.vue?vue&type=script&lang=js"
export * from "./NewHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./NewHistoryPage.vue?vue&type=style&index=0&id=709d1308&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports